export default function ServiceAreas() {
  const areas = [
    { name: 'Amsterdam', region: 'Noord-Holland', description: 'Expert PVC vloer leggen in de hoofdstad en omgeving', icon: 'ri-home-smile-line' },
    { name: 'Amstelveen', region: 'Noord-Holland', description: 'Vakkundige vloerinstallatie voor Amstelveen', icon: 'ri-home-smile-line' },
    { name: 'Haarlem', region: 'Noord-Holland', description: 'Premium vloeren voor Haarlem en omgeving', icon: 'ri-building-2-line' },
    { name: 'Zaandam', region: 'Noord-Holland', description: 'Moderne vloeroplossingen in Zaandam', icon: 'ri-community-line' },
    { name: 'Diemen', region: 'Noord-Holland', description: 'Vloerspecialist in Diemen', icon: 'ri-map-pin-line' },
    { name: 'Aalsmeer', region: 'Noord-Holland', description: 'Kwaliteit vloeren in Aalsmeer', icon: 'ri-map-pin-line' },
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-brass-50 text-brass-700 px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium mb-3 sm:mb-4">
            <i className="ri-map-pin-2-line"></i>
            Werkgebied
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-ink-900 mb-3 sm:mb-4">
            PVC vloer leggen in <span className="font-medium text-brass-600">Amsterdam & omgeving</span>
          </h2>
          <p className="text-sm sm:text-base text-ink-600 max-w-2xl mx-auto">
            Actief in alle grote steden in Noord-Holland. Professionele vloerinstallatie door ervaren leggers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 lg:gap-6">
          {areas.map((area, i) => (
            <div
              key={i}
              className="group relative bg-white border border-gray-200 rounded-2xl p-5 sm:p-6 transition-all duration-300 hover:shadow-xl hover:border-brass-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-brass-50 rounded-xl mb-3 sm:mb-4 transition-all duration-300 group-hover:bg-brass-600 group-hover:scale-110">
                <i className={`${area.icon} text-xl sm:text-2xl text-brass-600 transition-colors duration-300 group-hover:text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-medium text-ink-900 mb-0.5 sm:mb-1 transition-colors duration-300 group-hover:text-brass-600">
                {area.name}
              </h3>
              <p className="text-xs sm:text-sm text-gray-500 mb-2 sm:mb-3">{area.region}</p>
              <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4 leading-relaxed">{area.description}</p>
              <div className="flex items-center gap-2 text-brass-600 font-medium opacity-0 transform translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0">
                <span className="text-xs sm:text-sm">Meer informatie</span>
                <i className="ri-arrow-right-line text-base sm:text-lg group-hover:translate-x-1 transition-transform"></i>
              </div>
              <div className="absolute top-3 sm:top-4 right-3 sm:right-4 w-2 h-2 bg-brass-600 rounded-full opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <p className="text-ink-600 mb-3 sm:mb-4 text-sm sm:text-base">Staat uw stad er niet tussen? Neem contact met ons op!</p>
          <a
            href="tel:+31209876543"
            className="inline-flex items-center gap-2 bg-brass-600 hover:bg-brass-700 text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-full font-medium transition-all duration-300 hover:shadow-lg whitespace-nowrap text-sm sm:text-base"
          >
            <i className="ri-phone-line"></i>
            Bel ons voor beschikbaarheid
          </a>
        </div>
      </div>
    </section>
  );
}